import { createFileRoute } from "@tanstack/react-router";

import { BrandKitSettings } from "@/features/settings";

/**
 * ``/settings/brand-kits`` — Brand Kit surface (June 2026 design realignment).
 *
 * The single, generation-honored brand: colours + fonts (StyleSpec), document
 * chrome (logo / header / footer / cover / page geometry), brand voice (tone),
 * and an uploaded OOXML template (merge-on-top). Edits here drive every
 * generated doc/deck/sheet. BE: ``/api/v1/brand-kits``.
 */
export const Route = createFileRoute("/_authed/_modal/settings/brand-kits")({
  component: BrandKitSettings,
});
